import React from "react";
import BlackButton from "./BlackButton";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const TEXT_SHADOW = "drop-shadow-lg";
const FONT_STYLE =
  "font-bold text-[28px] md:text-5xl leading-normal tracking-normal";

const Banner = ({
  title,
  subtitle,
  description,
  className = "",
  hideSubtitleInWeb = false,
}) => {
  const navigate = useNavigate();

  const buttons = [
    {
      Component: BlackButton,
      onClick: () => navigate("/contact"),
      text: "Contact Us",
      icon: <ArrowRight />,
      ariaLabel: "Contact our team",
    },
  ];

  return (
    <>
      <section
        className={`flex flex-col mb-[8%] px-1 md:p-4 ${className}`}
        aria-label="Promotional banner"
      >
        <div className={`group relative p-[1px] bg-banner-border rounded-2xl`}>
          <div className="flex-1 flex relative bg-black rounded-2xl shadow-lg shadow-gray-700/30 ">
            <video
              className="absolute inset-0 w-full h-full object-cover rounded-2xl filter grayscale md:opacity-30"
              autoPlay
              loop
              muted
              playsInline
            >
              <source src="/videos/datapixl_footer.mp4" type="video/mp4" />
              <source src="/videos/datapixl_footer.webm" type="video/webm" />
              Your browser does not support the video tag.
            </video>

            <div className="text-white flex-1 items-center text-center md:text-start flex flex-col md:flex-row pt-16 md:pt-24 pb-20 md:pb-36 px-6 md:ps-20 md:pe-14 space-y-5 md:space-y-0 md:space-x-5">
              <div className="flex flex-col flex-1">
                <h1
                  className={`flex-1 ${FONT_STYLE} ${TEXT_SHADOW} mb-6 md:mb-0`}
                >
                  {title} <br className="hidden md:flex" />
                  <span className={`${hideSubtitleInWeb ? "md:hidden" : ""}`}>
                    {subtitle}
                  </span>
                </h1>
                {description && (
                  <h2 className="hidden md:block md:pt-4 text-white font-medium text-[28px] leading-[140%] tracking-[0%] z-10">
                    {description}
                  </h2>
                )}
              </div>

              {buttons.map(
                ({ Component, text, icon, ariaLabel, onClick }, index) => (
                  <Component
                    className="z-10"
                    key={index}
                    text={text}
                    icon={icon}
                    onClick={onClick}
                    aria-label={ariaLabel}
                  />
                )
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Banner;
